import {Fragment, useEffect, useState} from "react";
import {format} from "date-fns";
import PrivateBlogPostAPI from '~/api/privateBlogPostApi';
import {Link} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import classNames from "classnames/bind";
import styles from "./MainBlogPost.module.scss";
import Skeleton from "react-loading-skeleton";
const cx = classNames.bind(styles);

function MainBlogPost() {
    const [skBlogPost, setSkBlogPost] = useState([]);
    const [bBlogPost, setBBlogPost] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
            mirror: false
        });

        PrivateBlogPostAPI.getAll()
            .then((res) => {
                setSkBlogPost(res.data?.Results.filter(x => x.TypeId === 1));
                setBBlogPost(res.data?.Results.filter(x => x.TypeId === 2));
                setLoading(false);
            })
            .catch((err) => {});

    }, [])

    const mainSkBlogPost = skBlogPost.slice(0, 4).map((item) => ({
        ...item,
        FormattedDate: format(new Date(item.ModifiedDate), "MMM. do, yyyy"),
    }));
    const sidebarSkBlogPost = skBlogPost.slice(4, 11).map((item) => ({
        ...item,
        FormattedDate: format(new Date(item.ModifiedDate), "MMM. do, yyyy"),
    }));
    const lastBlogPost = mainSkBlogPost[3];

    const mainBBlogPost = bBlogPost.map((item) => ({
        ...item,
        FormattedDate: format(new Date(item.ModifiedDate), "MMM. do, yyyy"),
    }));
    const leftBBlogPost = mainBBlogPost.slice(0, 3);
    const middleBBlogPost = mainBBlogPost.slice(3, 9);

    return (
        <Fragment>
            <section>
                <div className="container-medium">
                    <div className="row">
                        <div className="mb-4 text-center text-sm-start col-12"><h4
                            className="text-primary fw-bolder mb-3">Blog</h4><h2>Self Knowing</h2></div>
                        <div className="text-center text-sm-start col-lg-6"><p>See the latest articles we published with
                            this dashboard. Your customers will be happy to find all the latest posts in one place. This
                            menu efficiently shows all related topics from search filters and provides the customers
                            with what they need.</p></div>
                        <div className="text-center text-sm-start col-lg-6"><p>Also, you can just educate your customers
                            about everything they need to know and follow to avail a service with you. This menu is the
                            one to show them that.</p></div>
                    </div>
                    {
                        loading && (
                            <div>
                                <Skeleton height={10} count={5} containerClassName="w-100" />
                            </div>
                        )
                    }
                    {
                        !loading && (
                            <div className="aos-init" data-aos="fade-up" data-aos-delay="100">
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className={cx("post-entry", "d-lg-flex aos-init mb-5")} data-aos="fade-up" data-aos-delay="200">
                                            <Link to={mainSkBlogPost[0]?.RoutePath}
                                                  className={cx("thumbnail", "me-4 mb-4 mb-lg-0 d-inline-block")}
                                            >
                                                <img
                                                    src={mainSkBlogPost[0]?.ThumbnailUrl}
                                                    alt='img'
                                                    className="img-fluid rounded-3"
                                                />
                                            </Link>
                                            <div>
                                                <div className="post-meta fs-9 mb-3">
                                                    <span>Self Knowing</span>
                                                    <span className="mx-1">•</span>
                                                    <span>{mainSkBlogPost[0]?.FormattedDate}</span>
                                                </div>
                                                <h4 className="mb-3">
                                                    <Link className="text-primary" to={mainSkBlogPost[0]?.RoutePath}>
                                                        {mainSkBlogPost[0]?.Title}
                                                    </Link>
                                                </h4>
                                                <p>{mainSkBlogPost[0]?.Description}</p>
                                                <span className="mb-3 d-block fs-9 fw-bold">Break Through</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4">
                                                {mainSkBlogPost?.slice(1, 3).map((item, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="post-list border-bottom aos-init"
                                                        data-aos="fade-up"
                                                        data-aos-delay={(idx + 1) * 100}
                                                    >
                                                        {
                                                            idx == 0 && (
                                                                <Link to={item.RoutePath}>
                                                                    <img
                                                                        src={item.ThumbnailUrl}
                                                                        alt='img'
                                                                        className="img-fluid rounded-3"
                                                                    />
                                                                </Link>
                                                            )
                                                        }
                                                        <div className="fs-9 my-3">
                                                            <span>Self Knowing</span>
                                                            <span className="mx-1">•</span>
                                                            <span>{item.FormattedDate}</span>
                                                        </div>
                                                        <h4 className="mb-2">
                                                            <Link className="text-primary"
                                                                  to={item.RoutePath}>{item.Title}</Link>
                                                        </h4>
                                                        <span className="mb-3 d-block fs-9 fw-bold">Break Through</span>
                                                        {idx === 0 && (
                                                            <p className="mb-4 d-block">{item.Description}</p>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="post-list">
                                                    <Link to={lastBlogPost?.RoutePath}>
                                                        <img
                                                            src={lastBlogPost?.ThumbnailUrl}
                                                            alt="img"
                                                            className="img-fluid rounded-3"
                                                        />
                                                    </Link>
                                                    <div className="my-3 fs-9">
                                                        <span>Self Knowing</span>
                                                        <span className="mx-1">•</span>
                                                        <span>{lastBlogPost?.FormattedDate}</span>
                                                    </div>
                                                    <h4 className="mb-2">
                                                        <Link className="text-primary"
                                                              to={lastBlogPost?.RoutePath}>{lastBlogPost?.Title}</Link>
                                                    </h4>
                                                    <span className="mb-3 d-block fs-9 fw-bold">Break Through</span>
                                                    <p className="mb-4 d-block">{lastBlogPost?.Description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        {sidebarSkBlogPost.map((item, idx) => (
                                            <div
                                                key={idx}
                                                className="post-list border-bottom aos-init"
                                                data-aos="fade-up"
                                                data-aos-delay={(idx + 3) * 100}
                                            >
                                                <div className={`${idx === 0 ? "mb-3" : "my-3"} fs-9`}>
                                                    <span>Self Knowing</span>
                                                    <span className="mx-1">•</span>
                                                    <span>{item.FormattedDate}</span>
                                                </div>
                                                <h5 className="mb-2">
                                                    <Link className="text-primary" href={item.RoutePath}>{item.Title}</Link>
                                                </h5>
                                                <span className="mb-3 d-block fs-9 fw-bold">Break Through</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </section>
            <section className="bg-body">
                <div className="container-medium">
                    <div className="row">
                        <div className="mb-4 text-center text-sm-start col-12"><h2>Benefits</h2></div>
                        <div className="text-center text-sm-start col-lg-6"><p>See the latest articles we published with
                            this dashboard. Your customers will be happy to find all the latest posts in one place. This
                            menu efficiently shows all related topics from search filters and provides the customers
                            with what they need.</p></div>
                        <div className="text-center text-sm-start col-lg-6"><p>Also, you can just educate your customers
                            about everything they need to know and follow to avail a service with you. This menu is the
                            one to show them that.</p></div>
                    </div>
                    {
                        loading && (
                            <div>
                                <Skeleton height={10} count={5} containerClassName="w-100" />
                            </div>
                        )
                    }
                    {
                        !loading && (
                            <div className="row g-5">
                                <div className="col-lg-4">
                                    {
                                        leftBBlogPost.length > 0 && (
                                            <div className="aos-init border-bottom" data-aos="fade-up" data-aos-delay="100">
                                                <Link to={leftBBlogPost[0].RoutePath}>
                                                    <img src={leftBBlogPost[0].ThumbnailUrl} alt="img" className="img-fluid rounded-3"/>
                                                </Link>
                                                <div className="fs-9 my-3">
                                                    <span className="date">Benefits</span>
                                                    <span className="mx-1">•</span>
                                                    <span>{leftBBlogPost[0].FormattedDate}</span>
                                                </div>
                                                <h4 className="mb-2">
                                                    <Link className="text-primary" to={leftBBlogPost[0].RoutePath}>
                                                        {leftBBlogPost[0].Title}
                                                    </Link>
                                                </h4>
                                                <p className="mb-4 d-block">{leftBBlogPost[0].Description}</p>
                                                <span className="mb-3 d-block fs-9 fw-bold">Break Through</span>
                                            </div>
                                        )
                                    }
                                    {
                                        leftBBlogPost.slice(1, 3).map((item, idx) => (
                                            <div key={idx} className={`aos-init ${idx === 0 ? "border-bottom" : ""} `} data-aos="fade-up" data-aos-delay={(idx + 1) * 100}>
                                                <div className="fs-9 my-3">
                                                    <span>Benefits</span>
                                                    <span className="mx-1">•</span>
                                                    <span>{item.FormattedDate}</span>
                                                </div>
                                                <h4 className="mb-2">
                                                    <Link className="text-primary" to={item.RoutePath}>
                                                        {item.Title}
                                                    </Link>
                                                </h4>
                                                <span className="mb-3 d-block fs-9 fw-bold">Break Through</span>
                                            </div>
                                        ))
                                    }
                                </div>

                                <div className="col-lg-8">
                                    <div className="row g-5">
                                        {
                                            [0, 1].map((item, idx) => {
                                                let startIndex = idx * 3;
                                                return (
                                                    <div key={idx} className="col-lg-4">
                                                        {
                                                            middleBBlogPost.slice(startIndex, startIndex + 3).map((item, index) => (
                                                                <div key={index} className="aos-init mb-5" data-aos="fade-up" data-aos-delay={(index + 1) * 100}>
                                                                    <Link to={item.RoutePath}>
                                                                        <img src={item.ThumbnailUrl} alt="img" className="img-fluid rounded-3"/>
                                                                    </Link>
                                                                    <div className="fs-9 my-3">
                                                                        <span>Benefits</span>
                                                                        <span className="mx-1">•</span>
                                                                        <span>{item.FormattedDate}</span>
                                                                    </div>
                                                                    <h5>
                                                                        <Link className="text-primary" to={item.RoutePath}>
                                                                            {item.Title}
                                                                        </Link>
                                                                    </h5>
                                                                    <span className="mb-3 d-block fs-9 fw-bold">Break Through</span>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                        <div className="col-lg-4">
                                            {
                                                middleBBlogPost.slice(0,5).map((item, idx) => (
                                                    <div key={idx} className="border-bottom aos-init" data-aos="fade-up" data-aos-delay={(idx + 1) * 100}>
                                                        <div className="fs-9 my-3">
                                                            <span className="date">Benefits</span>
                                                            <span className="mx-1">•</span>
                                                            <span>{item.FormattedDate}</span>
                                                        </div>
                                                        <h5 className="mb-2">
                                                            <Link className="text-primary" to={item.RoutePath}>
                                                                {item.Title}
                                                            </Link>
                                                        </h5>
                                                        <span className="mb-3 d-block fs-9 fw-bold">Break Through</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </section>
        </Fragment>
    )
}

export default MainBlogPost;